<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="4"></ucMenu>
          <div class="right_con">
            <div class="record_main">
              <div class="data_wrap">
                <div class="top_box">
                  <div class="filter">
                    <div class="filter_item">
                      平台：
                      <el-select
                          v-model="searchData.platform_type"
                          placeholder="全部平台"
                          clearable
                          filterable
                          @change="changeRefresh"
                      >
                        <el-option
                            v-for="item in platformList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                      </el-select>
                    </div>
                    <div class="filter_item">
                      店铺分组：
                      <el-select
                          v-model="searchData.group_ids"
                          placeholder="全部分组"
                          clearable
                          multiple
                          collapse-tags
                          filterable
                          @change="changeRefresh"
                      >
                        <el-option
                            v-for="item in groupList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                      </el-select>
                    </div>
                    <div class="filter_item">
                      统计日期：
                      <el-date-picker
                          style="border:none;width: 200px;font-size: 14px;padding: 0;"
                          v-model="selectDay"
                          type="daterange"
                          range-separator="-"
                          size="mini"
                          @change="changeDate"
                          value-format="yyyy-MM-dd"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                      </el-date-picker>
                    </div>
                    <div class="filter_item">
                      <span class="day_select" :class="{active:daySelectId == item.id}" v-for="(item,index) in daySelect" :key="index" @click="daySelectClick(item)">{{item.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="top_box" style="border-bottom: 1px solid #EEEEEE;padding: 10px 0;">
                  <div class="title">我的店群数据</div>
                  <div class="filter">
                  </div>
                </div>
                <div class="data_box">
                  <div
                      v-for="(item,index) in data_type_list"
                      :key="index"
                      class="data_item_wrap">
                    <el-tooltip
                        :disabled="!item.formula"
                        placement="top"
                        effect="light"
                        popper-class="profit-formula-tooltip">
                      <div slot="content" class="profit-formula-content">{{ item.formula }}</div>
                      <div
                          class="data_item"
                          :class="{ 'has-formula': !!item.formula, 'data_item_clickable': isDamagedDataItem(item) }"
                          @click="onDataItemClick(item)">
                        <p class="name">
                          {{item.name}}
                          <i v-if="item.formula" class="iconfont icon-shuomingtishi formula-tip-icon"></i>
                        </p>
                        <p class="val">{{item.val}}</p>
                        <div class="rate">{{compare_str}} <span class="rate_val" :class="{active:item.rate_type == 1}"><i class="iconfont icon-Gc_64_public-DeclineOutlined" v-if="item.rate != 0"></i>{{item.rate}}%</span></div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="data_wrap ranking_section">
                <div class="top_box">
                  <div class="ranking">
                    <span class="rank_item" :class="{active:rank_type == 1}" @click="changeRankType(1)">店铺排行</span>
                    <span class="rank_item" :class="{active:rank_type == 2}" @click="changeRankType(2)">款式排行</span>
                  </div>
                  <div class="filter">
                    <div class="filter_item">
                      店铺名
                      <el-select v-model="selectShop" filterable placeholder="请选择或输入" @change="changeShop" style="height: 36px;">
                        <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.shop_name"
                            :value="item.shop_id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="filter_item" style="padding-left: 0">
                      <el-select v-model="selectKeys" placeholder="商品名称" @change="changeKeys" style="width: 120px">
                        <el-option
                            v-for="item in keysList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                      <el-input v-model="keys_input" placeholder="请输入内容" @blur="changeKeysInput" style="border-left: 1px solid #ddd;width:180px"></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table_scroll_wrap" v-if="rank_type == 1">
                <el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#454545', width: '80px','font-weight': 'bold' }" v-loading="loading" ref="multipleTable" class="eltable eltable_one" :data="list" style="width: 100%;margin-top: 20px;">
                  <el-table-column align="center" property="scope" label="TOP" width="50">
                    <template slot-scope="scope">
                      <img :src="'https://admin.v2.xinghaohuo.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
                      <span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="left" property="shop_name" label="店铺名" min-width="150" fixed="left"></el-table-column>
                  <el-table-column align="center" property="all_sales" label="全店营业额" min-width="100"></el-table-column>
                  <el-table-column align="center" property="all_sales_orders" label="订单量" min-width="80"></el-table-column>
                  <el-table-column align="center" property="all_purchase" label="采购量" min-width="80"></el-table-column>
                  <el-table-column align="center" property="all_purchase_order_amount" label="采购应收" min-width="100"></el-table-column>
                  <el-table-column align="center" property="all_purchase_amount" label="采购应付" min-width="100"></el-table-column>
                  <!-- <el-table-column align="center" property="all_refund_shipping_num" label="退货发货量" width="100"></el-table-column> -->
                  <!-- <el-table-column align="center" property="all_refund_shipping" label="退货运费" width="100"></el-table-column> -->
                  <el-table-column align="center" property="all_refund_num" label="退货退款量" ></el-table-column>
                  <el-table-column align="center" property="all_refund_fee" label="退货退款额" ></el-table-column>
                  <el-table-column align="center" property="all_shipping_insurance" label="权益保险" ></el-table-column>
                  <el-table-column align="center" property="all_influencer_commission" label="达人佣金"></el-table-column>
                  <el-table-column align="center" property="all_timeout_compensation" label="超时赔付" ></el-table-column>
                  <el-table-column align="center" property="all_violation_compensation" label="判罚扣款" ></el-table-column>
                  <el-table-column align="center" property="all_small_amount_payment" label="小额打款" ></el-table-column>
                  <el-table-column align="center" property="all_shop_service_fee" label="平台服务费"></el-table-column>
                  <el-table-column align="center" property="all_qianchuan_fee" label="千川" min-width="80"></el-table-column>
                  <!-- <el-table-column align="center" property="all_other_shop_fee" label="其他店铺扣款" width="110"></el-table-column> -->
                  <!-- <el-table-column align="center" property="all_inventory_fee" label="铺货费" width="100"></el-table-column> -->
                  <!-- <el-table-column align="center" property="all_purchase_fee" label="采购费" width="100"></el-table-column> -->
                  <el-table-column align="center" property="all_shipping_num" label="发货量" ></el-table-column>
                  <el-table-column align="center" property="all_shipping_fee" label="代发费"></el-table-column>
                  <!-- <el-table-column align="center" property="all_vip_fee" label="会员费" width="100"></el-table-column> -->
                  <el-table-column align="center" property="all_reimbursement_amount" label="报销金额" width="100"></el-table-column>
                  <el-table-column align="center" property="all_total_profit" label="毛利润" ></el-table-column>
                </el-table>
              </div>
              <div class="table_scroll_wrap" v-if="rank_type == 2">
                <el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{background: '#eef1f6', color: '#454545', width: '80px','font-weight': 'bold' }" v-loading="loading" ref="multipleTable" class="eltable eltable_two" :data="list" style="width: 100%;margin-top: 20px;">
                  <el-table-column align="center" property="scope" label="TOP" width="50">
                    <template slot-scope="scope">
                      <img :src="'https://admin.v2.xinghaohuo.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
                      <span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" property="scope" label="商品图" width="80">
                    <template slot-scope="scope">
                      <img :src="scope.row.img" style="width: 40px;height: 40px;" />
                    </template>
                  </el-table-column>
                  <el-table-column align="left" property="name" label="商品名" width="360">
                    <template slot-scope="scope">
                      <p style="cursor: pointer" @click="goDetail(scope.row.goods_id)" target="_blank">{{ scope.row.name }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column align="left" property="shop_name" label="店铺名" width="140" show-overflow-tooltip></el-table-column>
                  <el-table-column align="center" property="all_sales" label="全部销售额" ></el-table-column>
                  <el-table-column align="center" property="all_purchase_order_amount" label="全部采购应收" ></el-table-column>
                  <el-table-column align="center" property="all_purchase_amount" label="全部采购应付" ></el-table-column>
                  <el-table-column align="center" property="all_sales_orders" label="全部单数"></el-table-column>
                  <el-table-column align="center" property="all_total_profit" label="全部毛利"></el-table-column>
                  <el-table-column align="center" property="all_profit_rate" label="全部毛利率">
                    <template slot-scope="scope">
                      {{scope.row.all_profit_rate}}%
                    </template>
                  </el-table-column>
                  <el-table-column align="center" property="all_refund_num" label="全部退单数" ></el-table-column>
                  <el-table-column align="center" property="all_refund_rate" label="全部退单率">
                    <template slot-scope="scope">
                      {{scope.row.all_refund_rate}}%
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="table_scroll_wrap" v-if="rank_type == 3">
                <el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266', width: '50px' }" v-loading="loading" ref="multipleTable" class="eltable eltable_three" :data="list" style="width: 100%;margin-top: 20px;">
                  <el-table-column align="center" property="scope" label="TOP" width="50">
                    <template slot-scope="scope">
                      <img :src="'/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
                      <span v-if="scope.row.ranking >= 4">{{scope.row.ranking}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" property="business_mobile" label="手机号" width=""></el-table-column>
                  <el-table-column align="center" property="all_sales" label="全店营业额" min-width="100"></el-table-column>
                  <el-table-column align="center" property="all_sales_orders" label="订单量"></el-table-column>
                  <el-table-column align="center" property="all_purchase" label="采购量" ></el-table-column>
                  <el-table-column align="center" property="all_purchase_order_amount" label="采购应收"></el-table-column>
                  <el-table-column align="center" property="all_purchase_amount" label="采购应付"></el-table-column>
                  <el-table-column align="center" property="all_refund_num" label="退货退款量"></el-table-column>
                  <el-table-column align="center" property="all_refund_fee" label="退货退款额"></el-table-column>
                  <el-table-column align="center" property="all_shipping_insurance" label="权益保险" ></el-table-column>
                  <el-table-column align="center" property="all_influencer_commission" label="达人佣金"></el-table-column>
                  <el-table-column align="center" property="all_timeout_compensation" label="超时赔付"></el-table-column>
                  <el-table-column align="center" property="all_violation_compensation" label="判罚扣款"></el-table-column>
                  <el-table-column align="center" property="all_small_amount_payment" label="小额打款" ></el-table-column>
                  <el-table-column align="center" property="all_shop_service_fee" label="平台服务费" ></el-table-column>
                  <el-table-column align="center" property="all_qianchuan_fee" label="千川"></el-table-column>
                  <el-table-column align="center" property="all_other_shop_fee" label="其他店铺扣款" ></el-table-column>
                  <el-table-column align="center" property="all_inventory_fee" label="铺货费"></el-table-column>
                  <el-table-column align="center" property="all_purchase_fee" label="采购费"></el-table-column>
                  <el-table-column align="center" property="all_shipping_fee" label="代发费"></el-table-column>
                  <el-table-column align="center" property="all_vip_fee" label="会员费"></el-table-column>
                  <el-table-column align="center" property="all_total_profit" label="毛利润"></el-table-column>
                </el-table>
              </div>
              <div class="turn_page">
                <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getRanking" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import {mapActions, mapState} from "vuex";
import Pagination from "@/components/pagination/pagination.vue";

export default {
  name: "ucenterStatistic",
  data() {
    return {
      rangeTime: "",
      startTime: "",
      endTime: "",
      tableData: [],
      statisticData: {},
      list: [],
      searchData: {
        platform_type:'',
        group_ids:[]
      },
      compare_str: '',
      rank_type: 1,
      daySelect: [
        {id: 1, name: '今天', day: '0'},
        {id: 2, name: '昨天', day: '1'},
        {id: 3, name: '近7天', day: '7'},
        {id: 4, name: '近30天', day: '30'},
        {id: 5, name: '近60天', day: '60'},
        {id: 6, name: '近90天', day: '90'},
        {id: 7, name: '近180天', day: '180'},
        {id: 8, name: '近一年', day: '365'},
        {id: 9, name: '本月', day: 'this_month'},
        {id: 10, name: '上月', day: 'prev_month'},
      ],
      daySelectId: 1,
      selectDay: "",
      page_data: {
        page: 1,
        limit: 10,
        total: 0
      },
      data_type_list: [],
      timeList: {},
      express_data_type_list: [
        {id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 2, name: '申通', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 3, name: '中通', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 4, name: '韵达', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 5, name: '极兔', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 6, name: '京东', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 7, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 8, name: '顺丰', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 9, name: '其他', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 10, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}

      ],
      express_output_type_list: [
        {id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 2, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
        {id: 3, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}
      ],
      shopList: [],
      selectShop: '',
      keysList: [{
        value: 'product_name',
        label: '商品名称',
      }],
      selectKeys: 'product_name',
      keys_input: '',
      groupList: [],
      platformList: [{'id':1, 'name':'抖店'}],
    }
  },
  components: {
    Pagination,
    myHead, myFoot, ucMenu
  },
  computed: {
    ...mapState({
      userinfo: (state) => state.login.userinfo,
    }),
  },
  created() {
    this.index()
    this.getRanking()
    this.loadGroupList();
    this.refreshTimer = setInterval(() => {
      this.index()
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  methods: {
    ...mapActions({
      getStatisticData: "ucenter_order/opGetStatisticData",
      getStatisticRanking: "ucenter_order/opGetStatisticRanking",
      getStatisticExpressData: "ucenter_order/opGetStatisticExpressData",
      checkBind: "ucenter_order/uShareBillCheckBind",
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
    }),
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || [];
          } else {
            this.$message.error(res.message || '获取分组失败');
          }
        }
      });
    },
    changeRankType(type) {
      this.rank_type = type
      this.page_data.page = 1
      this.getRanking()
    },
    changeShop() {
      this.searchData.shop_id = this.selectShop
      this.getRanking()
    },
    changeKeys() {
      this.searchData.keys = this.selectKeys
    },
    changeKeysInput(){
      this.getRanking()
    },
    goDetail(goods_id){
      this.$router.push({
        path: 'uc_statistic_product_detail',
        query: {
          goods_id: goods_id,
          menuId: 133
        }
      })
    },
    isDamagedDataItem(item) {
      return item && (item.key === 'all_damaged_goods_num' || item.key === 'all_damaged_goods_amount')
    },
    onDataItemClick(item) {
      if (!this.isDamagedDataItem(item)) {
        return
      }
      this.goDamagedOrders()
    },
    getDamagedTimeRange() {
      let startTs = 0
      let endTs = 0
      if (this.timeList.start_time && this.timeList.end_time) {
        startTs = Number(this.timeList.start_time)
        endTs = Number(this.timeList.end_time)
      } else if (this.searchData.start_time && this.searchData.end_time) {
        startTs = Math.floor(new Date(`${this.searchData.start_time} 00:00:00`).getTime() / 1000)
        endTs = Math.floor(new Date(`${this.searchData.end_time} 23:59:59`).getTime() / 1000)
      } else {
        const today = new Date()
        const yyyy = today.getFullYear()
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const dd = String(today.getDate()).padStart(2, '0')
        return [`${yyyy}-${mm}-${dd} 00:00:00`, `${yyyy}-${mm}-${dd} 23:59:59`]
      }
      const formatTime = (ts, endOfDay) => {
        const d = new Date(ts * 1000)
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        return endOfDay ? `${yyyy}-${mm}-${dd} 23:59:59` : `${yyyy}-${mm}-${dd} 00:00:00`
      }
      return [formatTime(startTs, false), formatTime(endTs, true)]
    },
    goDamagedOrders() {
      const damagedTime = this.getDamagedTimeRange()
      this.$router.push({
        path: '/uc_order',
        query: {
          damaged_filter: 'all',
          damaged_time_start: damagedTime[0],
          damaged_time_end: damagedTime[1]
        }
      })
    },
    index() {
      let params = {
        page: this.page,
        page_size: this.page_size,
      }
      params = Object.assign(params, this.searchData)
      this.getStatisticData({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            console.log('get share bill data', res)
            this.data_type_list = res.data.list
            this.express_data_type_list = res.data.expressData
            this.express_output_type_list = res.data.expressOutData
            this.compare_str = res.data.compare_str
            this.timeList = res.data.timeList || {}
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    getRanking() {
      let params = {limit: this.page_data.limit, page: this.page_data.page, type: this.rank_type, keys: this.selectKeys, keys_input: this.keys_input}
      if (this.page_data.page > 1 && this.shopList.length) {
        params.need_shop_list = 0
      }
      Object.assign(params, this.searchData)
      this.loading = true
      this.getStatisticRanking({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.list.data
            this.page_data.total = res.data.list.total
            if (res.data.shop_list && res.data.shop_list.length) {
              this.shopList = res.data.shop_list
            }
            this.loading = false
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    changeDate() {
      if (this.selectDay) {
        this.searchData.start_time = this.selectDay[0];
        this.searchData.end_time = this.selectDay[1]
        this.daySelectId = ''
        this.searchData.select_day = ''
      } else {
        this.searchData.start_time = ''
        this.searchData.end_time = ''
        this.daySelectId = 1
        this.searchData.select_day = this.daySelect[0].day
      }

      this.index()
      this.getRanking()
    },
    daySelectClick(e) {
      console.log(e)
      this.selectDay = ''
      this.searchData.start_time = ''
      this.searchData.end_time = ''
      this.daySelectId = e.id
      this.searchData.select_day = e.day
      this.index()
      this.getRanking()
    },
    changeRefresh(val){
      // if(this.$store.state.login.user_level == 9 && this.searchData.group_ids) {
      //   this.searchData.group_ids = []
      //   this.$message.error('普通会员无法使用分组');
      //   return
      // }
      this.index()
      this.getRanking()
    },
    selection(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length == 0
    },
    currentChange(val) {
      this.page = val
      this.getShareBill()
      console.log(val)
    }
  }
}

</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}

.record_main{padding: 30px 40px 40px;background: #fff;line-height: 1;box-sizing: border-box;max-width: 100%;overflow: hidden;}
.data_wrap.ranking_section{margin-top: 20px;padding-top: 20px;border-top: 1px solid #EEEEEE;}

.data_wrap .top_box{display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap;gap: 10px;}
.data_wrap .top_box .title{font-weight: bold;font-size: 14px;color: #000000;}
.data_wrap .top_box .filter{display: flex;font-weight: 400;font-size: 14px;color: #737E97;min-height: 32px;flex-wrap: wrap;gap: 10px;max-width: 100%;}
.data_wrap .top_box .filter .filter_item{border-radius: 6px;border: 1px solid #DCDFE6;display: flex;align-items: center;padding-left:15px;margin-right: 0;flex-wrap: wrap;min-height:36px;max-width: 100%;box-sizing: border-box;}
.data_wrap .top_box .filter .filter_item .day_select{border-right:1px solid #E1EBFE;height:100%;display:flex;align-items:center;padding-right: 10px;margin-right: 10px;cursor: pointer;white-space: nowrap;}
.data_wrap .top_box .filter .filter_item .day_select.active{color: #236CFF;}
.data_wrap .top_box .filter .filter_item .day_select:last-child{border-right:none;margin-right: 0px;}
.data_wrap .top_box .filter .filter_item:last-child{margin-right: 0px;}
.data_wrap .top_box .filter .tips_box{display: flex;align-items: center;}
.data_wrap .top_box .filter .tips_box .desc{display: flex;align-items: center;border-right:2px solid #E1EBFE;line-height:15px;padding-right: 10px;margin-right: 10px;}
.data_wrap .top_box .filter .tips_box .iconfont{font-size:12px;color:#737E97;margin-left: 3px;}

.data_wrap .data_box{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  align-content: flex-start;
}
.data_wrap .data_box .data_item_wrap{
  width: calc((100% - 70px) / 8);
  flex: 0 0 calc((100% - 70px) / 8);
  min-width: 0;
  margin: 0;
}
.data_wrap .data_box .data_item_wrap :deep(.el-tooltip){display: block;width: 100%;}
.data_wrap .data_box .data_item{width: 100%;height: 100px;background: #FFFFFF;border-radius: 6px;box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0);padding: 12px;transition: all 0.3s ease;box-sizing: border-box;}
.data_wrap .data_box .data_item:hover {box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0.8);transform: translateY(-5px);}
.data_wrap .data_box .data_item.data_item_clickable{cursor: pointer;}
.data_wrap .data_box .data_item.data_item_clickable:hover {box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0.8);transform: translateY(-5px);}
.data_wrap .data_box .data_item.active{box-shadow: 0 0 15px 2px rgba(236, 243, 255, 1);}
.data_wrap .data_box .data_item .name{font-size: 12px;color: #454545;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.data_wrap .data_box .data_item .val{font-weight: normal;font-size: 22px;color: #000000;}
.data_wrap .data_box .data_item .rate{font-weight: 400;font-size: 14px;color: #454545;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.data_wrap .data_box .data_item .rate .rate_val{color: #2CD9C5;}
.data_wrap .data_box .data_item .rate .rate_val .iconfont{margin:0 6px;display: inline-block;}
.data_wrap .data_box .data_item .rate .rate_val.active{color: #F52929;}
.data_wrap .data_box .data_item .rate .rate_val.active .iconfont { transform: scaleY(-1);}
.data_wrap .data_box .data_item.has-formula .name{display: flex;align-items: center;}
.data_wrap .data_box .data_item .formula-tip-icon{font-size: 12px;color: #737E97;margin-left: 4px;}

.data_wrap .top_box .ranking{height: 36px;border-radius: 6px;border: 1px solid #DCDFE6;display: flex;align-items: center;padding: 0 2px;}
.data_wrap .top_box .ranking .rank_item{width: 80px;height: 30px;background: #FFFFFF;border-radius: 6px;display: flex;align-items: center;justify-content: center;color: #737E97;font-size:14px;cursor: pointer;}
.data_wrap .top_box .ranking .rank_item.active{background: #F0413E;color: #fff;}

:deep(.filter_item .el-range-editor--mini .el-range-separator) {
  line-height: 36px !important;
}
:deep(.filter_item .el-input__inner) {
  border: none !important; /* 或者使用其他自定义边框样式 */
  height: 36px !important;
}
:deep(.el-table th.el-table__cell>.cell){
  padding: 0 !important;
}
.el-table th{
  white-space: nowrap;
}
:deep(.eltable_one .el-table__cell:nth-child(2)>.cell){
  padding-left: 10px !important;
}
:deep(.eltable_two .el-table__cell:nth-child(3)>.cell){
  padding-left: 10px !important;
}
:deep(.el-date-editor){
  margin-top: 0 !important;
}
.el-table .cell{white-space: nowrap;text-overflow: initial;}
.table_scroll_wrap {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table_scroll_wrap :deep(.el-table) {
  min-width: max-content;
}
.turn_page {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
</style>
<style>
.profit-formula-tooltip {
  max-width: 520px;
}
.profit-formula-content {
  white-space: pre-line;
  line-height: 1.6;
  font-size: 13px;
  color: #454545;
}
</style>
